import React, { useState } from "react";
import ActionButton from "../../components/query/button";

const priorities = ["Low", "Medium", "High"];

export default function NewQuery() {
  const [form, setForm] = useState({
    subject: "",
    details: "",
    priority: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePriority = (level) => {
    setForm({ ...form, priority: level });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(form);
  };

  return (
    <div className="min-h-screen">
      <p className=" font-bold">Query Management</p>
      <div className="w-full max-w-3xl p-10">
        <h1 className="text-2xl font-semibold mb-2">Submit a New Query</h1>
        <p className="text-gray-500 mb-6">
          Fill out the form below to submit a new query.
        </p>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="space-y-6"
        >
          {/* Subject */}
          <div>
            <label className="block text-sm font-medium mb-2">Subject</label>
            <input
              type="text"
              name="subject"
              value={form.subject}
              onChange={handleChange}
              placeholder="Enter subject of your query"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-[#1234CD]"
            />
          </div>

          {/* Details */}
          <div>
            <label className="block text-sm font-medium mb-2">Details</label>
            <textarea
              name="details"
              value={form.details}
              onChange={handleChange}
              placeholder="Provide details about your query"
              rows={4}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-[#1234CD]"
            />
          </div>

          {/* Priority */}
          <div>
            <label className="block text-sm font-medium mb-3">Priority</label>

            <div className="flex gap-3">
              {priorities.map((level) => (
                <button
                  type="button"
                  key={level}
                  onClick={() => handlePriority(level)}
                  className={`px-4 py-2 rounded-lg border text-sm transition 
                    ${
                      form.priority === level
                        ? "bg-blue-600 text-white border-blue-600"
                        : "bg-gray-100 text-[#1234CD] border-gray-200 hover:bg-gray-200"
                    }`}
                >
                  {level}
                </button>
              ))}
            </div>

            <p className="text-sm text-gray-400 mt-2">
              Choose the priority level
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-4  pt-4">
            <ActionButton
              label="Cancel"
              variant="outline"
            />

            <ActionButton label="Submit Query" />
          </div>
        </form>
      </div>
    </div>
  );
}
